module.exports = __webpack_public_path__ + "img/UC@2X.4ffd46e3.png";